<div [formGroup]="importRowForm" fxLayout="column" fxLayoutGap="15px">

  <div fxLayout="row" fxLayoutGap="15px" class="button-container">
    <button tabindex="-1"
            (click)="save()"
            [class.spinner]="processingRequest"
            [disabled]="!importRowForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz </span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">

    <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

      <mat-card>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
          <h3>Nagroda</h3>
          <app-dict-warehouse-products
            fxFlex="100"
            label="Produkt"
            [formControl]="importRowProductControl">
          </app-dict-warehouse-products>

          <app-detail
            header="Nagroda (dane z pliku)"
            [value]="importRowObject?.product">
          </app-detail>

          <mat-form-field fxFlex="50">
            <mat-label>Liczba</mat-label>
            <input matInput placeholder="liczba"
                   type="number"
                   min="0"
                   formControlName="amount"
                   [required]="false">
          </mat-form-field>

          <app-detail-bool header="Wymagany protokół"
                           [value]="importRowObject?.warehouseProduct?.protocol">
          </app-detail-bool>

          <app-detail-bool header="Podpisany protokół"
                           [value]="importRowObject?.protocolSigned">
          </app-detail-bool>

          <app-detail fxFlex="100" header="Wydanie"
                      [value]="importRowObject?.competitionWz?.number">
          </app-detail>
        </div>
      </mat-card>

      <mat-card>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
          <h3>Struktura</h3>
          <app-detail
            *ngIf="importRowObject?.ofwca?.fullName"
            header="OFWCA"
            [value]="importRowObject?.ofwca?.fullName"
            [link]="['/ofwca/szczegoly', importRowObject?.ofwca?.uuid]">
          </app-detail>
          <app-detail
            *ngIf="importRowObject?.partner?.shortName"
            header="Partner"
            [value]="importRowObject?.partner?.shortName"
            [link]="['/partnerzy/szczegoly', importRowObject?.partner?.uuid]">
          </app-detail>
          <app-detail
            *ngIf="importRowObject?.ofwca"
            header="Regionalny"
            [value]="importRowObject?.ofwca?.assetsRegional?.fullName">
          </app-detail>
          <app-detail
            *ngIf="importRowObject?.partner"
            header="Regionalny"
            [value]="importRowObject?.partner?.assetsRegional?.fullName">
          </app-detail>
        </div>
      </mat-card>

    </div>

    <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

      <mat-card>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
          <h3>Szczegóły</h3>
          <app-detail
            header="Konkurs"
            [value]="importRowObject?.competitionImport.competitionName">
          </app-detail>
          <mat-form-field fxFlex="100">
            <mat-label>Konkurs rozliczany na</mat-label>
            <mat-select [formControl]="typeControl" [required]="true" [multiple]="false">
              <mat-option value="partner">Partner</mat-option>
              <mat-option value="ofwca">OFWCA</mat-option>
            </mat-select>
          </mat-form-field>
          <app-dict-ofwcas
            *ngIf="typeControl.value === 'ofwca'"
            fxFlex="100"
            label="OFWCA"
            [control]="ofwcaControl">
          </app-dict-ofwcas>
          <app-dict-partners
            *ngIf="typeControl.value === 'partner'"
            fxFlex="100"
            label="Partner"
            [control]="partnerControl">
          </app-dict-partners>

          <app-detail
            header="Miejsce w rankingu"
            [value]="importRowObject?.ranking">
          </app-detail>
        </div>
      </mat-card>

    </div>

  </div>

  <div fxLayout="row" fxLayoutGap="15px" class="button-container">
    <button tabindex="-1"
            (click)="save()"
            [class.spinner]="processingRequest"
            [disabled]="!importRowForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz </span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>
  </div>

</div>
